import React from 'react';
import { Link } from 'react-router-dom';
import { Share2, Car, Store, Globe, CheckCircle, ChevronRight } from 'lucide-react';
import { LABELS, ONBOARDING_STEPS } from '../../constants/dashboard';

const ICONS = { Share2, Car, Store, Globe };

const OnboardingChecklist = ({ completedSteps }) => {
  const pendingSteps = ONBOARDING_STEPS.filter(s => !completedSteps[s.id]);

  if (pendingSteps.length === 0) return null;

  const totalSteps = ONBOARDING_STEPS.length;
  const doneCount = totalSteps - pendingSteps.length;
  const progressPct = Math.round((doneCount / totalSteps) * 100);

  return (
    <div className="bg-dark-card rounded-xl border border-dark-border p-5">
      <div className="flex items-center justify-between mb-1">
        <h2 className="text-base font-semibold text-primary">{LABELS.onboardingTitle}</h2>
        <span className="text-xs text-carmin font-medium">{doneCount}/{totalSteps}</span>
      </div>
      <p className="text-xs text-muted mb-4">{LABELS.onboardingSubtitle}</p>

      {/* Progress bar */}
      <div className="w-full h-1.5 bg-dark-hover rounded-full mb-4">
        <div
          className="h-full bg-carmin rounded-full transition-all duration-500"
          style={{ width: `${progressPct}%` }}
        />
      </div>

      <div className="space-y-2">
        {ONBOARDING_STEPS.map((step) => {
          const Icon = ICONS[step.icon];
          const isDone = completedSteps[step.id];

          return (
            <Link
              key={step.id}
              to={step.route}
              className={`flex items-center gap-3 p-3 rounded-lg border transition-all ${
                isDone
                  ? 'bg-dark-hover border-green-900/30 opacity-60'
                  : 'bg-dark-hover border-dark-border hover:border-carmin/40'
              }`}
            >
              <div className={`flex items-center justify-center w-8 h-8 rounded-lg flex-shrink-0 ${
                isDone ? 'bg-green-500/10' : 'bg-carmin-50'
              }`}>
                {isDone
                  ? <CheckCircle className="h-4 w-4 text-green-500" />
                  : <Icon className="h-4 w-4 text-carmin" />
                }
              </div>
              <div className="flex-1 min-w-0">
                <p className={`text-sm font-medium ${isDone ? 'text-muted line-through' : 'text-primary'}`}>
                  {LABELS[step.labelKey]}
                </p>
                <p className="text-xs text-muted">{LABELS[step.descKey]}</p>
              </div>
              {!isDone && <ChevronRight className="h-4 w-4 text-muted flex-shrink-0" />}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default OnboardingChecklist;
